// extracted by mini-css-extract-plugin
module.exports = {"SearchWrapper":"FavoriteDocuments_SearchWrapper__1gP0n","FavoritPageTitle":"FavoriteDocuments_FavoritPageTitle__7vbpF"};